<div class="row">
  <div class="col-lg-12">
    <div class="col-lg-12">
      <div class="card">
        <!-- Card header -->
        <div class="card-header border-0">
          <div class="row">
            <h3 *ngIf="!isStudentView" class="mb-0">Events for {{module.name}}</h3>
            <h3 *ngIf="isStudentView" class="mb-0">Upcoming Events</h3>
          </div>
        </div>
        <!-- Light table -->
        <div class="table-responsive">
          <table class="table align-items-center table-flush table-hover">
            <!-- <thead>
                    <tr>
                        <th colspan="4" class="text-right"> Total : </th><th class="text-right">₦{{this.util.numberWithCommas(sumTotal)}}</th>
                    </tr>
                </thead> -->
            <thead class="thead-light">
              <tr>
                <th> Subject </th>
                <th class="text-center"> Status </th>
                <th *ngIf="module.allowBatches"> Batch</th>
                <th> Lesson</th>
                <th> Start Date</th>
                <th> End Date</th>
                <th class="mb-0 text-center"> Details</th>
                <th *ngIf="!isStudentView" class="mb-0 text-center"> Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of schoolModuleEvent">
                <td>{{item.subject}}</td>
                <td [ngClass]="{ 'bg-red': item.isCancelled, 'bg-green': !item.isCancelled && !isExpired(item),'bg-yellow': !item.isCancelled && isExpired(item) }">{{ item.isCancelled ?
                  'Cancelled' : isExpired(item)? 'Expired':'Active'}}</td>
                <td *ngIf="module.allowBatches">{{item.batchName}}</td>
                <td>{{item.lessonTitle}}</td>
                <td>{{this.util.formatDate(item.inviteStartDate)}}</td>
                <td>{{this.util.formatDate(item.inviteEndDate)}}</td>
                <td class="mb-0"><button class="btn btn-primary" [disabled]="item.isCancelled" (click)="popUpDetails(item)">View Details</button></td>
                <td *ngIf="!isStudentView" class="mb-0">
                    <div class="btn-group d-flex justify-content-center" role="group" aria-label="Button group with nested dropdown">
                      <button class="btn btn-primary mr-1" [disabled]="item.isCancelled" (click)="cancelEvent(item)">Cancel Event</button>
                      <button *ngIf="canDownloadAttendance(item.venue)" class="btn btn-primary ml-1 p-0" [disabled]="item.isCancelled" (click)="downloadAttendance(item)">Download Attendance</button>
                    </div>

                </td>
              </tr>
            </tbody>
          </table>
          <p *ngIf="schoolModuleEvent.length<=0" class="text-center">No Available event</p>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="upcomingEventModal" data-keyboard="false" data-backdrop="static" aria-hidden="true" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body pt-0">
        <div class="text-uppercase">
          <h3 class="modal-title text-center mb-2">Event for {{eventDetail.eventName}}</h3>
          <h4 class="text-primary-darker text-left mb-0 d-inline">{{ eventDetail.isLink ? 'Meeting Link:' : 'Venue:' }}</h4>
          <a *ngIf="eventDetail.isLink" [href]="eventDetail.venue" target="_blank"><p class="text-sm font-italic d-inline text-underline text-lowercase"> {{eventDetail.venue.length < 85 ? eventDetail.venue : 'Click here'}}</p></a>
          <p class="d-inline" *ngIf="!eventDetail.isLink"> {{eventDetail.venue}} </p>
          <div>
            <h4 class="text-primary-darker d-inline text-left mb-0">Start Time: </h4>
            <p class="d-inline">{{this.util.formatDate(eventDetail.start)}}</p>
          </div>
          <div>
            <h4 class="text-primary-darker d-inline text-left mb-0">End Time: </h4>
            <p class="d-inline">{{this.util.formatDate(eventDetail.end)}}</p>
          </div>
          <div *ngIf="eventDetail.lessonTitle">
            <h4 class="text-primary-darker d-inline text-left mb-0">Lesson Title: </h4>
            <p class="d-inline">{{eventDetail.lessonTitle}}</p>
          </div>
        </div>
        <div id="eventdescriptionbody" class="bodycontainer card shadow-sm-darker p-3 mt-3" [innerHTML]="eventDetail.body"></div>
        <div class="d-flex justify-content-center flex-wrap gap-1.5">
          <button type="button" class="btn m-0" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</div>
